import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const ColumnWrapper = styled.div`
  font-family: var(--font-paragraphs);
  min-width: 225px;
  flex: 1 1 0px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  padding: ${({ $padding }) => $padding};
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    padding-inline: 0;
  }
`;

const Column = ({
  children,
  className,
  style,
  verticalAlignment,
  width,
  backgroundColor,
  textColor,
  padding,
}) => {
  const wrapperProps = {};
  if (className) {
    wrapperProps["className"] = className;
  }
  if (style) {
    wrapperProps["style"] = style;
  }
  if (verticalAlignment) {
    wrapperProps["style"] = {
      ...wrapperProps["style"],
      justifyContent:
        verticalAlignment === "bottom"
          ? "flex-end"
          : verticalAlignment === "center"
          ? "center"
          : "flex-start",
    };
  }
  if (width) {
    wrapperProps["style"] = {
      ...wrapperProps["style"],
      flexGrow: width.replace(/%/g, ""),
    };
  }
  if (backgroundColor) {
    wrapperProps["style"] = {
      ...wrapperProps["style"],
      backgroundColor: backgroundColor,
    };
  }
  if (textColor) {
    wrapperProps["style"] = {
      ...wrapperProps["style"],
      color: textColor,
    };
  }
  return (
    <ColumnWrapper $padding={padding} {...wrapperProps}>
      {children}
    </ColumnWrapper>
  );
};

Column.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  verticalAlignment: PropTypes.oneOf(["top", "center", "bottom"]),
  width: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  padding: PropTypes.string,
};

Column.defaultProps = {
  children: undefined,
  className: undefined,
  style: undefined,
  verticalAlignment: undefined,
  width: undefined,
};

export default Column;
